import { config } from "./config";
import { editMenu } from "./edit-menu";
import { menu } from "./menu";
import { orderReport } from "./order-report";
import { productReport } from "./product-report";
import { products } from "./products";
import { vendorReport } from "./vendor-report";
export const coala = {
	config,
	editMenu,
	menu,
	orderReport,
	productReport,
	products,
	tabs: {
		config: "Configurações",
		menu: "Cardápios",
		orderReport: "Relatório de pedidos",
		productReport: "Relatório por produto",
		products: "Produtos",
		vendorReport: "Relatório de vendors",
	},
	vendorReport,
};
